module.exports = __webpack_public_path__ + "img/guide_3_4.078e0cbb.svg";